import { render, staticRenderFns } from "./changeCommerceToCompanyForm.vue?vue&type=template&id=775d6116&"
import script from "./changeCommerceToCompanyForm.vue?vue&type=script&lang=ts&"
export * from "./changeCommerceToCompanyForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports